import { render, staticRenderFns } from "./MusicServer.vue?vue&type=template&id=804c05a4&scoped=true&"
import script from "./MusicServer.vue?vue&type=script&lang=js&"
export * from "./MusicServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804c05a4",
  null
  
)

export default component.exports